import React, { useRef, forwardRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import './Record.css'
import { useReactToPrint } from 'react-to-print';
import { FormControl, FormLabel, FormHelperText, Paper, useForkRef } from '@material-ui/core';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
// import 'paper-css'

const useStyles = makeStyles({
    table: {
        border: "1px double",
        borderCollapse: "collapse",
        borderSpacing: 0,
        padding: "20px",
        margin: "20px",
    },
    column: {
    },
    td: {
        border: "1px double",

    }
});


const Results = forwardRef((props, ref) => {
    const classes = useStyles();


    return (
        <div>
            <table class="tg" >
                <colgroup>
                    <col style={{ width: " 34px" }} />
                    <col style={{ width: " 34px" }} />
                    <col style={{ width: " 25px" }} />
                    <col style={{ width: " 39px" }} />
                    <col style={{ width: " 25px" }} />
                    <col style={{ width: "168px" }} />
                    <col style={{ width: " 39px" }} />
                    <col style={{ width: " 41px" }} />
                    <col style={{ width: " 110px" }} />
                    <col style={{ width: " 81px" }} />
                    <col style={{ width: " 147px" }} />
                </colgroup>
                <thead>
                    <tr>
                        <th class="tg-0pky" colspan="2">專案名稱</th>
                        <th class="tg-0pky" colspan="4">2021寵愛－特１</th>
                        <th class="tg-0pky">姓名</th>
                        <th class="tg-0pky" colspan="2">陳宜琳</th>
                        <th class="tg-0pky">檢查年月日</th>
                        <th class="tg-0pky">2021/06/06</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="tg-0pky" colspan="2">廠別</td>
                        <td class="tg-6jxd" colspan="4"></td>
                        <td class="tg-0pky">生日</td>
                        <td class="tg-0pky" colspan="2">１９９６／１０／１３</td>
                        <td class="tg-0pky">受雇年月日</td>
                        <td class="tg-0pky"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="2">部門</td>
                        <td class="tg-6jxd" colspan="4"></td>
                        <td class="tg-0pky">工號</td>
                        <td class="tg-0pky" colspan="2"></td>
                        <td class="tg-0pky">電話</td>
                        <td class="tg-0pky"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="2">性別</td>
                        <td class="tg-6jxd">女</td>
                        <td class="tg-6jxd">地址</td>
                        <td class="tg-6jxd" colspan="5"></td>
                        <td class="tg-0pky">身分證號</td>
                        <td class="tg-0pky">N１２３１２３１２３</td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="4">現在從事ＸＸＸＸ</td>
                        <td class="tg-6jxd" colspan="4"></td>
                        <td class="tg-0pky">檢查時期</td>
                        <td class="tg-0pky" colspan="2"></td>
                    </tr>
                    <tr>
                        <td class="tg-lboi" rowspan="23">檢<br />查<br />項<br />目</td>
                        <td class="tg-0pky" colspan="4">作業經歷</td>
                        <td class="tg-6jxd" colspan="6"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="4">既往病史</td>
                        <td class="tg-6jxd" colspan="6"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" rowspan="8">各<br />系<br />統</td>
                        <td class="tg-0pky" colspan="3">頭頸部</td>
                        <td class="tg-0pky" colspan="6"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="3">呼吸</td>
                        <td class="tg-0pky" colspan="6"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="3">心臟</td>
                        <td class="tg-0pky" colspan="6"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="3">消化</td>
                        <td class="tg-0pky" colspan="6"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="3">神經</td>
                        <td class="tg-0pky" colspan="6"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="3">肌肉骨骼</td>
                        <td class="tg-0pky" colspan="6"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="3">皮膚</td>
                        <td class="tg-0pky" colspan="6"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="3">醫師問診</td>
                        <td class="tg-0pky" colspan="6"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="4">身高</td>
                        <td class="tg-0pky" colspan="4"></td>
                        <td class="tg-0pky">體重</td>
                        <td class="tg-0pky"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="4">腰圍</td>
                        <td class="tg-0pky" colspan="4"></td>
                        <td class="tg-0pky">視力</td>
                        <td class="tg-0pky"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="4">辨色力</td>
                        <td class="tg-0pky" colspan="4"></td>
                        <td class="tg-0pky">聽力</td>
                        <td class="tg-0pky"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="4">血壓</td>
                        <td class="tg-0pky" colspan="6"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="4">尿蛋白</td>
                        <td class="tg-0pky" colspan="4"></td>
                        <td class="tg-0pky">尿淺血</td>
                        <td class="tg-0pky"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="4">血色素</td>
                        <td class="tg-0pky" colspan="4"></td>
                        <td class="tg-0pky">白血球</td>
                        <td class="tg-0pky"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="4">血糖</td>
                        <td class="tg-0pky" colspan="6"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="4">血清</td>
                        <td class="tg-0pky" colspan="6"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="4">肌酸酐</td>
                        <td class="tg-0pky" colspan="6"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="4">膽固醇</td>
                        <td class="tg-0pky" colspan="6"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="4">三酸甘油酯</td>
                        <td class="tg-0pky" colspan="6"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="4">高密度</td>
                        <td class="tg-0pky" colspan="4"></td>
                        <td class="tg-0pky">低密度</td>
                        <td class="tg-0pky"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="4">胸部Ｘ</td>
                        <td class="tg-0pky" colspan="6">無明顯異常</td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="2">應注意及<br />處理事項</td>
                        <td class="tg-0pky" colspan="9"></td>
                    </tr>
                    <tr>
                        <td class="tg-0pky" colspan="3">檢查機構</td>
                        <td class="tg-0pky" colspan="6"></td>
                        <td class="tg-0pky">健檢醫師</td>
                        <td class="tg-0pky"></td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
})

// export default Results;


const MultipleComponet = React.forwardRef((props, ref) => {


    return (
        <div ref={ref}>
            <Results />
        </div>
    )
})

const Example = () => {
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    return (
        <div>
            <MultipleComponet ref={componentRef} />
            <button onClick={handlePrint}>Print this out!</button>
        </div>
    );
};


export default Example;
